import { createSlice } from "@reduxjs/toolkit";
import { getCurrentStepAPI } from "../../../services/guestUsers/guestUserAllAPIService";
const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const getCurrentStepsSlice = createSlice({
  name: "getCurrentStepsSlice",
  initialState: data,
  reducers: {
    getCurrentStepsSliceInfo(state) {
      state.isLoading = true;
      state.message = "";
    },
    getCurrentStepsSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    getCurrentStepsSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
      state.data = null;
    },
    getCurrentStepsSliceReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const getCurrentStepsHandler = (data = {}) => async (dispatch) => {
  try {
    dispatch(getCurrentStepsSliceAction.getCurrentStepsSliceInfo());
    const response = await getCurrentStepAPI(data);
    dispatch(getCurrentStepsSliceAction.getCurrentStepsSliceSuccess(response));
  } catch (e) {
    const msg =
      typeof e === "string"
        ? e
        : e?.message || "Unable to load enrollment step";
    dispatch(getCurrentStepsSliceAction.getCurrentStepsSliceFailure(msg));
  }
};
export default getCurrentStepsSlice.reducer;
export const getCurrentStepsSliceAction = getCurrentStepsSlice.actions;
